import { IAppState } from '../../redux';

export function selectTopBetsSerpUrl(state: IAppState): string | null {
  const {
    topBets: { serpUrl },
  } = state;

  return serpUrl;
}
